export default ({ cache }) => {
  if (cache.garbageCollectionId) {
    clearInterval(cache.garbageCollectionId);
  }
};
